module.exports = __webpack_public_path__ + "static/media/girl_02_mouth_close.43b3f03c.png";